import { LicenseData } from "@/model/data/License/LicenseData";
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import Vue from "vue";
import { MutationTree } from "vuex";
import { LicenseState } from "./state";
import _ from "lodash";
import { Installation } from "@/model/data/Installation";

export const SET_ACTIVE_LICENSE = "SET_ACTIVE_LICENSE";
export const SET_LICENSES_DATA_SUMMARY = "SET_LICENSES_DATA_SUMMARY";
export const RESET_LICENSE_LOCALLY = "RESET_LICENSE_LOCALLY";
export const REMOVE_LICENSE_LOCALLY = "REMOVE_LICENSE_LOCALLY";
export const ADD_LICENSE_LOCALLY = "ADD_LICENSE_LOCALLY";
export const SET_INSTALLATIONS = "SET_INSTALLATIONS";
export const SET_LOCAL_INSTALLATIONS = "SET_LOCAL_INSTALLATIONS";

export default {
    [SET_ACTIVE_LICENSE](state: LicenseState, payload: LicenseData) {
        Vue.set(state, "licenseModules", payload);
    },
    [SET_LICENSES_DATA_SUMMARY](state: LicenseState, payload: []) {
        state.licensesDataSummary = this.localInstallations = _.cloneDeep(payload);
        state.licensesDataSummaryLocal = this.localInstallations = _.cloneDeep(payload);
        // Vue.set(state, "licensesDataSummary", payload);
        // Vue.set(state, "licensesDataSummaryLocal", payload);
    },
    [RESET_LICENSE_LOCALLY](state: LicenseState, payload: []) {
        state.licensesDataSummaryLocal = _.cloneDeep(state.licensesDataSummary);
    },
    [REMOVE_LICENSE_LOCALLY](state: LicenseState, module: LicenseModuleEnum) {
        console.debug("assignedLicenses--");
        state.licensesDataSummaryLocal.filter((l) => l.module == module)[0].assignedLicenses--;
    },
    [ADD_LICENSE_LOCALLY](state: LicenseState, module: LicenseModuleEnum) {
        console.debug("assignedLicenses++");
        state.licensesDataSummaryLocal.filter((l) => l.module == module)[0].assignedLicenses++;
    },
    [SET_INSTALLATIONS](state: LicenseState, installations: Installation[]) {
        state.installations = _.cloneDeep(installations);
    },
    [SET_LOCAL_INSTALLATIONS](state: LicenseState, installations: Installation[]) {
        state.localInstallations = _.cloneDeep(installations);
    },
} as MutationTree<LicenseState>;
